export const isLoadingI18n = state => state?.i18n?.isLoading
